<template>
  <b-select :value="value" @input="$emit('input', $event)" ref="input" :state="state" :options="optionsForSelect"/>
</template>

<script>
import baseInput from './_base'

function tryProperties(object, properties) {
  if (!object) return
  return properties.find(prop => object.hasOwnProperty(prop))
}

export default {
  mixins: [baseInput],

  props: {
    options: { type: Array },
  },

  data() {
    const sampleOption = this.options[0]
    const valueMethod = tryProperties(sampleOption, ['value', 'id'])
    const textMethod = tryProperties(sampleOption, ['text', 'name', 'label', 'toS'])

    return {
      optionsForSelect: this.options.map(option => {
        if (typeof option === 'string') {
          return { value: option, text: option }
        } else {
          return {value: option[valueMethod], text: option[textMethod]}
        }
      }),
    }
  },
}
</script>

<style lang="scss">
.live-input .form-control.custom-select {
  height: 3.125rem;
  padding-left: 1.2rem;
  padding-top: 0;
  padding-bottom: 0;

  &:not(:focus) {
    border-bottom: 2px solid $gray-300;
  }

  &:hover {
    border-bottom: 2px solid $secondary;
  }
}
</style>
